import React, { Component } from "react";
import { injectIntl } from "react-intl";
import ReactGA from "react-ga";
import querystring from "query-string";
import {
  getCountries,
  getDestinationDetails,
  getMarketCart,
  getRequestLocale,
  finishCartCheckout,
  getRecommendedFavorites,
  getCategoryDetails,
} from "../src/api";
import {
  Footer,
  HeaderBar,
  LoginModal,
  NavigationBar,
  Experiences,
  NotFavourites
} from "../src/components";
import Checkout from "../src/components/Checkout";
import Head from "next/head";
import { getUserInfo } from "../src/utils/auth";
import HomeNavBarSmall from "../src/components/HomeNavBar/HomeNavBarSmall";

const getConfig = require("next/config").default;
const { publicRuntimeConfig } = getConfig();
const { GOOGLE_TAG_ID } = publicRuntimeConfig;

ReactGA.initialize(GOOGLE_TAG_ID);

class FavoritesScreen extends Component {
  static async getInitialProps(ctx) {
    const { asPath, req } = ctx;
    const locale = await getRequestLocale(req, asPath);
    const pathWithoutQueryString = asPath.split("?")[0];
    const pathParams = pathWithoutQueryString.split("/");
    const destination = await getDestinationDetails(pathParams[2], locale);
    const countries = await getCountries();
    const user = await getUserInfo(ctx);
    var recommendeds = [];
    if(user && user.is_logged){
      recommendeds = await getRecommendedFavorites(locale, user.token, pathParams[2], 'para_ti', '');
    }
    return {
      pathname: asPath,
      lang: locale,
      destination,
      user,
      countries,
      recommendeds
    };
  }
  loginModal = React.createRef();
  constructor(props){
    super(props);
    this.state = {
      recommendeds: this.props.recommendeds,
      category: {
        rawId: 'para_ti',
        name: this.translate("sidebar.menu.for_you"),
        descriptionShort: ''
      }
    }
  }
  componentDidUpdate() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  translate = (id, params = {}, options = {}) => {
    return this.props.intl.formatMessage({ id }, params, options);
  };
  getCategories = () => {
    return [
      { rawId: "wetravelhum", name: ''},
      { rawId: "para_ti", name: this.translate("sidebar.menu.for_you") },
    ].concat(this.props.destination.categories);
  };
  onSearchChanged = (text, categoryRawId) => {
    let qs = querystring.stringify({ query: text });
    Router.push(
      `/${this.props.intl.locale}/${this.props.destination.rawId}/search?${qs}`
    );
  };

  onCategoryChange = (categoryRawId) => {
    const { lang, user, destination } = this.props;
    getCategoryDetails(categoryRawId, destination.rawId, lang, {}).then((category) => {
      getRecommendedFavorites(lang, user.token, destination.rawId, category.rawId, '').then((recommendeds) => {
        this.setState({ category, recommendeds });
      })
    });
  }

  onRemoveFavorite = (item) => {
    const { recommendeds } = this.state;
    console.log(item);
    console.log(recommendeds);
    const index = recommendeds.findIndex(recommended => {
      console.log(recommended.rawId === item.rawId);
      return recommended.rawId === item.rawId
    });
    console.log(index);
    if(index !== -1){
      recommendeds.splice(index, 1)
    }

    this.setState({ recommendeds });
  }

  renderData(){
    const { recommendeds, category } = this.state;
    console.log(recommendeds);
    console.log(category)
    if(recommendeds.length === 0){
      return(
        <NotFavourites
          href={`/?locale=${this.props.intl.locale}&destination=${this.props.destination.rawId}`}
          as={`/${this.props.intl.locale}/${this.props.destination.rawId}`}
        />
      )
    }
    return(
      <React.Fragment>
        <Experiences
            swipeable={false}
            see_more={false}
            href={`/${this.props.intl.locale}/${this.props.destination.rawId}/${category.rawId}`}
            title={category.name}
            categoryRawId={category.rawId}
            description={category.descriptionShort}
            highlights={undefined}
            data={recommendeds}
            isReccomended={true}
            destination={this.props.destination}
            onRemoveFavorite={this.onRemoveFavorite} />
      </React.Fragment>
    )
  }
  render() {
    const { category } = this.state;
    const onLoginRequest = () => {
      if (this.loginModal.current) this.loginModal.current.show();
    };

    return (
      <>
        <Head>
          <title>{this.translate("checkout.title")} - Discoolver</title>
        </Head>

        <HomeNavBarSmall
          ref={this.heroContent}
          locale={this.props.lang}
          destination={this.props.destination}
          destinations={this.props.destinations}
          background={this.props.destination.image}
          user={this.props.user}
        />

        <LoginModal
          destination={this.props.destination}
          ref={this.loginModal}
        />

        {this.renderData()}

        <Footer destination={this.props.destination} />
      </>
    );
  }
}

export default injectIntl(FavoritesScreen);
